<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

      v-card(flat)
        v-card-title.pa-0
          v-row.px-5.pt-3.pb-2(v-if="hasChanges" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic100--text {{ $t('save_changes') }}
            v-col.ml-3.shrink
              v-layout
                v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clickRevert()")
                  .button-AA-small.basic100--text {{ $t('cancel') }}
                v-btn.my-auto.basic100(depressed small @click="clickSave()" :loading="isLoading")
                  .button-AA-small.primary500--text {{ $t('save') }}
          
          v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.primary500--text {{ $t('courier') }}

        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

        v-card-text.pa-0.pb-12(v-else)
          .header.px-4.mt-4
            .s1 Yezza Shipping
            .c1.basic600--text {{ $t('yezza_shipping_desc') }}
            a.c1.textColorAccent--text.text-decoration-none(href="https://help.yezza.com/hc/en-my/articles/4412895578265-What-is-Yezza-Shipping-" target="_blank") {{ $t('learn_more') }}
          
          v-form.mt-4(ref="form")
            v-card.pt-4.mx-4(flat style="border:1px solid var(--v-basic300);")
              .header.px-4
                .s1 {{ $t('section_courier.title') }}
                .p1.mt-2 {{ $t('section_courier.text') }}

              .courier.pr-4.pl-2(v-for="(courier, index) in courier.shipping_const" :key="courier.id")
                v-divider.basic300(v-if="index != 0")
                v-row(align='center')
                  v-col.shrink
                    y-switch.mb-n3.mr-n3(:color="$vuetify.theme.themes[$theme].success400" v-model="shippingObject(courier).enabled" @change="onUpdateCourier(shippingObject(courier), true)" :disabled="shippingObject(courier).out_of_service || (shippingObject(courier).required_dropoff_point && !shippingObject(courier).dropoff_point)")
                  v-col.clickable(@click.stop="shippingObject(courier).out_of_service ? '' : openCourierDetails(shippingObject(courier))")
                    v-row(align='center')
                      v-col
                        .s2.basic700--text {{ courier.name }}
                        .c1.basic600--text(v-if="shippingObject(courier).out_of_service") {{ $t('section_courier.not_available') }}
                      v-col.shrink.pr-0(v-if="shippingObject(courier).preferred")
                        v-chip(x-small outlined color="basic600" :style="{ 'background-color': $vuetify.theme.themes[$theme].basic600T08 + '!important' }")
                          .c1.basic600--text {{ $t('preferred') }}
                      v-col.shrink
                        eva-icon.mt-1(name="arrow-ios-forward-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="20" height="20")
            
            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .s1 {{ $t('section_rates.title') }}
              v-row
                v-col
                  .s2.basic700--text {{ $t('section_rates.use_automatic') }}
                  .c1.basic600--text {{ $t('section_rates.use_automatic_text') }}
                v-col.shrink
                  y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="useAutomaticShippingRate")
              
              .enable(v-if="!useAutomaticShippingRate")
                v-divider.basic300
                .custom.mt-4
                  .p1.basic800--text {{ $t('section_rates.customize_rates') }}
                  v-radio-group.mt-n1(v-model="customShippingRate" hide-details)
                    v-radio.mt-3(value='markup' style="width:100%" color="textColorAccent")
                      template(v-slot:label)
                        div.s2.textColorDefault--text {{ $t('section_rates.markup_rates') }}
                    .details.ml-8
                      .c1.basic600--text {{ $t('section_rates.markup_rates_text') }}
                      .amount.mt-4(v-if="customShippingRate == 'markup'")
                        .mb-1.label.basic600--text.text-uppercase {{ $t('section_rates.markup_amount') }}
                        v-text-field.mt-2(v-model='markupAmount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                        .c1.basic600--text.mt-2 {{ $t('section_rates.markup_amount_text') }}
                        .c1.basic600--text.mt-2 {{ $t('section_rates.markup_example') }}
                        div.ml-13
                          .c1.basic600--text {{ $t('section_rates.markup_example_time') }}
                          .c1.basic600--text {{ $t('section_rates.markup_example_fee') }}
                    v-divider.basic300.my-4
                    v-radio.mt-3(value='flat' style="width:100%" color="textColorAccent")
                      template(v-slot:label)
                        div.s2.textColorDefault--text {{ $t('section_rates.flat_rate') }}
                    .details.ml-8
                      .c1.basic600--text {{ $t('section_rates.flat_rate_text') }}
                      .amount.mt-4(v-if="customShippingRate == 'flat'")
                        .mb-1.label.basic600--text.text-uppercase {{ $t('section_rates.flat_rate') }}
                        v-text-field.mt-2(v-model='flatAmount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                        .c1.basic600--text.mt-2 {{ $t('section_rates.flat_rate_info') }}
            
            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .s1 {{ $t('section_offer_free.title') }}
              v-row
                v-col
                  .c1.basic600--text.mt-3 {{ $t('section_offer_free.pays_full') }}
                v-col.shrink
                  y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="courier.free_shipping_enabled")
              
              .disable(v-if="courier.free_shipping_enabled")
                v-divider.basic300
                .price.mt-4
                  .mb-1.label.basic600--text.text-uppercase {{ $t('section_offer_free.order_amount') }}
                  v-text-field.mt-2(v-model='orderAmount' placeholder="0" background-color="basic200" outlined dense height="40" type="number" :rules="rules.has_quantity" :prefix="$currency.symbol" hide-details="auto")
                  .c1.basic600--text.mt-2 {{ $t('section_offer_free.order_amount_text') }}

            v-card.py-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .header.px-4
                .s1 {{ $t('section_address.title') }}
                .c1.basic600--text {{ $t('section_address.text') }}
              
              v-divider.basic300.my-4
              
              .pickup-address.px-4
                v-row.pa-0.clickable(@click="showUpdateCourierAddress = true")
                  v-col.py-0(v-if="courier.pickup_address")
                    .label.basic600--text.text-uppercase.my-auto {{ $t('section_address.pickup_address') }}
                    .p2.basic700--text {{ courier.pickup_address.address_1 }}, {{ courier.pickup_address.address_2 }}, {{ courier.pickup_address.postcode }}, {{ courier.pickup_address.city }}, {{ courier.pickup_address.state }}, {{ courier.pickup_address.country }}
                    .p2.basic700--text(v-if="courier.pickup_address.phone") {{ courier.pickup_address.phone | phoneFormat }}
                  v-col.py-0.shrink
                    eva-icon(name="arrow-ios-forward-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="20" height="20")
              
              //- v-divider.basic300.my-4

              //- .awb-address.px-4
              //-   v-row.pa-0.clickable(@click="showUpdateCourierAwbAddress = true")
              //-     v-col.py-0
              //-       .label.basic600--text.text-uppercase.my-auto AWB address
              //-       .different-address(v-if="courier.awb_address")
              //-         .p2.basic700--text {{ courier.awb_address.address_1 }}, {{ courier.awb_address.address_2 }}, {{ courier.awb_address.postcode }}, {{ courier.awb_address.city }}, {{ courier.awb_address.state }}, {{ courier.awb_address.country }}
              //-         .p2.basic700--text(v-if="courier.awb_address.phone") {{ courier.awb_address.phone | phoneFormat }}
              //-       .p2.basic600--text(v-else) Same as pickup address
              //-     v-col.py-0.shrink
              //-       eva-icon(name="arrow-ios-forward-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="20" height="20")

            //- v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .s1 Air Waybill (AWB)
              .p1.mt-2 Select default AWB format for printing
              v-radio-group.mt-2(v-model='courier.awb_format' row dense hide-details)
                v-radio.mb-3(value='A4' style="width:100%" color="textColorAccent")
                  template(v-slot:label)
                    div.p1.textColorDefault--text A4
                v-radio.mb-3(value='Sticker' style="width:100%" color="textColorAccent")
                  template(v-slot:label)
                    div.p1.textColorDefault--text Sticker (4 inch x 6 inch)

    .modals
      courier-method(v-if="showUpdateCourierMethod" :open.sync="showUpdateCourierMethod" :courier.sync="courier" :shipping.sync="selectedShipping" @update-enabled="onUpdateCourier")
      courier-address(v-if="showUpdateCourierAddress" :open.sync="showUpdateCourierAddress" :company.sync="company" @check-address="updateAddress()" @finished="fetchShippingCourier()" :isEditing="true" :courier.sync="courier")
      courier-awb-address(v-if="showUpdateCourierAwbAddress" :open.sync="showUpdateCourierAwbAddress" :company.sync="company" :courier.sync="courier" @finished="fetchShippingCourier()")
            
</template>

<script>
import { mapActions } from 'vuex'
import CourierMethod from '@/components/dialogs/settings/yezzashipping/CourierMethod.vue'
import CourierAddress from '@/components/dialogs/settings/yezzashipping/CourierAddress.vue'
import CourierAwbAddress from '@/components/dialogs/settings/yezzashipping/CourierAwbAddress.vue'
export default {
  name: 'CourierSettings',
  components: { CourierMethod, CourierAddress, CourierAwbAddress },
  props: ['open', 'company'],
  data: () => ({
    isFetching: false,
    originalCourier: null,
    courier: {},
    selectedShipping: null,
    showUpdateCourierMethod: false,
    showUpdateCourierAddress: false,
    showUpdateCourierAwbAddress: false,
    addressChanged: false,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasChanges () {
      if (Object.keys(this.courier).length > 0 && JSON.stringify(this.courier) !== JSON.stringify(this.originalCourier)) {
        return true
      }
      return false
    },
    useAutomaticShippingRate: {
      get() {
        if (Object.keys(this.courier).length > 0) {
          return !this.courier.custom_rates_enabled
        }
        return false
      },
      set(newValue) {
        this.courier.custom_rates_enabled  = !newValue
      }
    },
    customShippingRate: {
      get() {
        if (Object.keys(this.courier).length > 0) {
          if (this.courier.flat_rate != null) {
            return 'flat'
          }
          if (this.courier.markup_rate != null) {
            return 'markup'
          }
        }
        return null
      },
      set(newValue) {
        if (newValue == 'flat') {
          if (this.originalCourier && this.originalCourier.flat_rate) {
            this.courier.flat_rate = this.originalCourier.flat_rate
          } else {
            this.courier.flat_rate = 0
          }
          this.courier.markup_rate = null
        } else {
          if (this.originalCourier && this.originalCourier.markup_rate) {
            this.courier.markup_rate = this.originalCourier.markup_rate
          } else {
            this.courier.markup_rate = 0
          }
          this.courier.flat_rate = null
        }
      }
    },
    markupAmount: {
      get() {
        if (Object.keys(this.courier).length > 0) {
          return this.courier.markup_rate/this.$currency.multiplier
        }
        return 0
      },
      set(newValue) {
        this.courier.markup_rate = parseInt((parseFloat(newValue)).toFixed(this.$currency.exponent).replace('.', ''))
      }
    },
    flatAmount: {
      get() {
        if (Object.keys(this.courier).length > 0) {
          return this.courier.flat_rate/this.$currency.multiplier
        }
        return 0
      },
      set(newValue) {
        this.courier.flat_rate = parseInt((parseFloat(newValue)).toFixed(this.$currency.exponent).replace('.', ''))
        this.courier.markup_rate = null
      }
    },
    orderAmount: {
      get() {
        if (Object.keys(this.courier).length > 0) {
          return this.courier.free_shipping/this.$currency.multiplier
        }
        return false
      },
      set(newValue) {
        this.courier.free_shipping = parseInt((parseFloat(newValue)).toFixed(this.$currency.exponent).replace('.', ''))
      }
    }
  },
  mounted () {
    this.fetchShippingCourier()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openCourierDetails (shipping) {
      this.selectedShipping = shipping
      this.showUpdateCourierMethod = true
    },
    shippingObject(courier) {
      let selectedShippings = []
      let shippings = []
      if (Object.keys(this.courier).length > 0) {
        selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
        shippings = this.courier.available_shipping
      }
      let shipping = shippings.filter(f => f.title === courier.name)
      const choices = shippings.filter(f => f.title === courier.name)
      if (shipping.length > 1) {
        const dropoff = shipping.filter(f => f.service_type === 'dropoff')
        if (dropoff.length > 0) {
          shipping = dropoff[0]
        } else {
          shipping = shipping[0]
        }
      } else {
        shipping = shipping[0]
      }
      let selectedShipping = selectedShippings.filter(f => f.title === courier.name)
      let isSelected = selectedShipping.length > 0

      if (!shipping) {
        return { out_of_service: true, enabled: isSelected }
      }
      let isPrefered = this.courier.preferred ===  shipping.service_id
      let dropoffPoint = null
      const dropoff = selectedShippings.filter(f => f.service_id === shipping.service_id).filter(f => f.service_type === shipping.service_type)[0]
      if (dropoff && dropoff.dropoff_point) {
        dropoffPoint = dropoff.dropoff_point
      }
      let data = {
        ...shipping,
        name: courier.name,
        enabled: isSelected,
        preferred: isPrefered,
        choices: choices,
        data: shipping,
        required_dropoff_point: courier.required_dropoff_point,
        dropoff_point: dropoffPoint
      }
      return data
    },
    onUpdateCourier (shipping, updateBoth) {
      let selectedShippings = this.courier.available_shipping.filter(f => f.enabled)
      if (this.courier.channel === 'ys_malaysia') {
        let selectedShipping = selectedShippings.find(f => f.title === shipping.title)
        if (selectedShipping) {
          this.courier.available_shipping.filter(f => f.title === shipping.title).forEach(o => {
            this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
          })
        } else {
          this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === shipping.service_id)], 'enabled', true)
        }
      } else {
        if (updateBoth) {
          let selectedShipping = selectedShippings.filter(f => f.title === shipping.title)
          this.courier.available_shipping.filter(f => f.title === shipping.title).forEach(o => {
            if (selectedShipping.length > 0) {
              this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', false)
            } else {
              this.$set(this.courier.available_shipping[this.courier.available_shipping.findIndex(f => f.service_id === o.service_id)], 'enabled', true)
            }
          })
        }
      }
      this.courier.selected_shipping = this.courier.available_shipping.filter(f => f.enabled)
    },
    fetchShippingCourier() {
      this.isFetching = true
      this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/courier`)
        .then((response) => {
          this.courier = JSON.parse(JSON.stringify(response.data))
          this.originalCourier = JSON.parse(JSON.stringify(response.data))
        }).catch(() => {})
        .finally(() => { this.isFetching = false })
    },
    clickRevert () {
      this.courier = JSON.parse(JSON.stringify(this.originalCourier))
      this.addressChanged = false
    },
    updateAddress () {
      this.addressChanged = (JSON.stringify(this.courier.pickup_address) !== JSON.stringify(this.originalCourier.pickup_address))
    },
    async clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      await this.axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/courier/${this.courier.id}`, this.courier)
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.message) {
            this.showMessage(['error', e.response.data.message])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
      await this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/courier`)
        .then((response) => {
          this.courier = { ...response.data }
          this.originalCourier = { ...response.data }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "yezza_shipping_desc": "Enjoy fast, reliable logistic services with our delivery partners",
    "section_courier": {
      "title": "Courier services",
      "text": "Enable desired courier services below:",
      "not_available": "Not available in your area"
    },
    "section_rates": {
      "title": "Shipping rates",
      "use_automatic": "Use automatic shipping rates",
      "use_automatic_text": "Charge the most accurate rates based on weight, destination and courier services",
      "customize_rates": "Customize your shipping rates",
      "markup_rates": "Markup rates",
      "markup_rates_text": "Charge additional markup amount on top of real time rates",
      "markup_amount": "Markup amount",
      "markup_amount_text": "This amount will be added to calculated real time rate",
      "markup_example": "Example: Markup amount = RM 4.00",
      "markup_example_time": "time rates = RM 5.00",
      "markup_example_fee": "fee charge = RM 12.00",
      "flat_rate": "Flat rate",
      "flat_rate_text": "Charge one flat rate for every order regardless of weight, destination or courier service",
      "flat_rate_info": "This rate will be offered to all customers who require shipping"
    },
    "section_offer_free": {
      "title": "Offer customers free shipping",
      "pays_full": "Merchant pays the full shipping fee for orders over a certain amount.",
      "order_amount": "Order amount",
      "order_amount_text": "Free shipping automatically offered when total order exceeds this amount"
    },
    "section_address": {
      "title": "Address for courier",
      "text": "Manage your pickup address & Air Waybill (AWB) address",
      "pickup_address": "Pickup address"
    }
  },
  "id": {
    "yezza_shipping_desc": "Nikmati layanan logistik yang cepat dan kamul dengan mitra pengiriman kami",
    "section_courier": {
      "title": "Jasa Kurir",
      "text": "Aktifkan jasa kurir yang diinginkan di bawah ini:",
      "not_available": "Tidak tersedia di wilayah kamu"
    },
    "section_rates": {
      "title": "Tarif pengiriman",
      "use_automatic": "Gunakan tarif pengiriman otomatis",
      "use_automatic_text": "Mengenakan biaya paling akurat berdasarkan berat, tujuan, dan layanan kurir",
      "customize_rates": "Sesuaikan tarif pengiriman kamu",
      "markup_rates": "Markup Rate",
      "markup_rates_text": "Kenakan jumlah biaya markup tambahan di atas tarif waktu nyata",
      "markup_amount": "Jumlah Markup",
      "markup_amount_text": "Jumlah ini akan ditambahkan untuk menghitung tarif waktu nyata",
      "markup_example": "Contoh: Jumlah markup = Rp 40.00",
      "markup_example_time": "tarif waktu = Rp 50.00",
      "markup_example_fee": "biaya = Rp 120.00",
      "flat_rate": "Flat rate",
      "flat_rate_text": "Kenakan biaya satu flat rate untuk setiap pesanan tanpa mementingkan berat, tujuan dan jasa kurir",
      "flat_rate_info": "Rate ini akan ditawarkan untuk semua pelanggan yang membutuhkan pengiriman"
    },
    "section_offer_free": {
      "title": "Tawarkan gratis ongkir kepada pelanggan",
      "pays_full": "Penjual membayar ongkir penuh untuk pesanan dalam jumlah tertentu.",
      "order_amount": "Jumlah pesanan",
      "order_amount_text": "Gratis ongkir secara otomatis ditawarkan ketika total pesanan melebihi jumlah ini"
    },
    "section_address": {
      "title": "Alamat untuk kurir",
      "text": "Kelola alamat pengambilan kamu & alamat Air Waybill (AWB)",
      "pickup_address": "Alamat pengambilan"
    }
  }
}
</i18n>